import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';
import {connect} from 'react-redux';
import {setTabIndex} from '../../HeaderBlockSlice';

const TabSwitch = ({headerData: {tabIndex, tabs}, context, setShowMenu}) => {
  const handleOnClick = (index) => {
    setTabIndex(index);
    setShowMenu(false);
    prepareSameWindowUrlWithNavigateTo(tabs[index]?.lobbyLink?.value, context);
  };

  return (
    <div className='switch-tab'>
      {tabs &&
        tabs?.map((tab, index) => {
          if (index !== tabIndex) {
            return (
              <div className='tab' key={index} onClick={() => handleOnClick(index)}>
                {tab.mobileMenuIcon?.expandedValue?.contentLink?.url && (
                  <Image src={Config.epiBaseUrl + tab.mobileMenuIcon?.expandedValue?.contentLink?.url} />
                )}
                {tab.mobileMenuText?.value}
              </div>
            );
          }
          return null;
        })}
    </div>
  );
};
const mapStateToProps = () => ({});
const mapDispatchToProps = {
  setTabIndex,
};

export default connect(mapStateToProps, mapDispatchToProps)(TabSwitch);
